import React from "react"
import tw, { css } from "twin.macro"
import { useMediaQuery } from "react-responsive"

import Needle from "./needle"
import SpeedoBackground from "../svgs/speedoBackground"
import SpeedoLabelButton from "./speedoLabel"

interface SpeedometerProps {
  selectedIndex: number
  positions: number[]
  duration: number
  onClick: (index: number) => void
}

const Speedometer: React.FC<SpeedometerProps> = ({
  duration,
  positions,
  selectedIndex,
  onClick,
}) => {
  const isSmall = useMediaQuery({ query: "(max-width: 767px)" })
  const angle = angleFromIndex(selectedIndex, isSmall)

  return (
    <div
      css={[
        css`
          position: relative;
          height: 100%;
          width: 100%;
        `,
      ]}
    >
      {/* Background */}
      <SpeedoBackground
        css={[
          tw`absolute object-fill`,
          css`
            height: 100%;
            width: 100%;
          `,
        ]}
      />

      {positions.map((hours, idx) => {
        return (
          <div
            key={idx}
            css={[
              css`
                position: absolute;
                left: ${labelPositions[idx].left};
                top: ${labelPositions[idx].top};
              `,
            ]}
          >
            <SpeedoLabelButton
              selected={selectedIndex == idx}
              onClick={() => {
                onClick(idx)
              }}
              hours={hours}
            />
          </div>
        )
      })}

      {/* The Needle */}
      <div
        css={[
          tw`absolute`,
          css`
            left: 45%;
            top: 30%;
            @media (min-width: 768px) {
              left: 46.5%;
              top: 32%;
            }
          `,
        ]}
      >
        <Needle angle={angle} />
      </div>
    </div>
  )
}

interface PositionData {
  left: string
  top: string
}

const labelPositions: PositionData[] = [
  // Bottom left
  { left: "17.5%", top: "75%" },
  // Top left
  { left: "17.5%", top: "33%" },
  // Top middle
  { left: "50%", top: "8%" },
  // Top right
  { left: "82.5%", top: "33%" },
  // Bottom right
  { left: "82.5%", top: "75%" },
]

// Get the angle from a given duration
function angleFromIndex(index: number, isSmall: boolean): number {
  if (!isSmall) {
    switch (index) {
      case 0:
        return -120
      case 1:
        return -60
      case 3:
        return 60
      case 4:
        return 120
      default:
      case 2:
        return 0
    }
  }
  switch (index) {
    case 0:
      return -112
    case 1:
      return -55
    case 3:
      return 55
    case 4:
      return 112
    default:
    case 2:
      return 0
  }
}

export default Speedometer
